import { render, staticRenderFns } from "./PageMealsPerDay.vue?vue&type=template&id=660fef41"
import script from "./PageMealsPerDay.vue?vue&type=script&lang=js"
export * from "./PageMealsPerDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports